export const COUPONS_ERRORS = {
  missing_term_sheet: "Pas de term sheet : les coupons seront créés à l'ajout du term sheet",
  coupons_already_exist: 'Des coupons existent déjà pour ce produit, aucun coupon ne sera créé',
  product_not_closed: 'Produit non clôturé : les coupons seront créés à la clôture',
  term_sheet_coupons_not_found: 'Tableau des coupons introuvable dans le term sheet',
  term_sheet_coupons_invalid: 'Tableau des coupons du term sheet illisible',
  total_below_invested: "Total inférieur au montant investi : les coupons seraient calculés sur un mauvais total",
}

export const couponsErrorLabel = (error) => error && (COUPONS_ERRORS[error] || `Coupons non créés : ${error}`)
